import { request } from "services/request";

const resource = "api/driverJobs";

const getControlPoints = (bidId: number) => request(`${resource}/getControlPoints/${bidId}`, { method: "GET" });

export { getControlPoints };
